module.exports = __webpack_public_path__ + "static/media/Firebase.a0460b95.png";